import { Link } from 'react-router-dom';
import ROUTES from '../../routes/Routes.js';
import ValidationErrors from '../../components/alerts/ValidationErrors.jsx';
import { useLogin } from '../../hooks/auth/useLogin.js';
import imgLogin from '../../images/auth/login.svg';
import ConfirmLogout from '../../components/modales/ConfirmLogout.jsx';


export default function Login() {
    const {
        form,
        error,
        success,
        validationErrors,
        isAuthenticated,
        loading,
        handleChange,
        submit,
        logout,
        clearValidationErrors
    } = useLogin();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await submit();
    };

    if (loading) return null;

    // Modal cuando el usuario YA está autenticado 
    if (isAuthenticated) {
        return (
            <ConfirmLogout
                show={true}
                onLogout={logout}
            />
        );
    }

    return (
        <>
            {/* Formulario SOLO si NO está autenticado */}
            <section className="p-3 p-md-4 p-xl-5">
                <div className="container">
                    <div className="card border-light-subtle shadow-sm">
                        <div className="row g-0">
                            <div className="col-12 col-md-6" style={{ height: '470px', overflow: 'hidden' }}>
                                <img src={imgLogin} className="img-fluid rounded-start w-100 h-100" alt="login" />
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="card-body p-3 p-md-4 p-xl-5">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="mb-3">
                                                <h3>Iniciar sesión</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row gy-3 gy-md-4 overflow-hidden">
                                            <div className="col-12">                                                                                            
                                                <input type="text" className="form-control" maxLength="30" name="username" placeholder="Usuario" autoComplete="username" value={form.username} onChange={handleChange} required />
                                            </div>
                                            <div className="col-12">                                                                                           
                                                <input type="password" className="form-control" maxLength="255" name="password" placeholder="Contraseña" autoComplete="password" value={form.password} onChange={handleChange} required />
                                            </div>
                                            <div className="col-12">
                                                <div className="d-grid">
                                                    {/* Muestra el error del validator del backend */}
                                                    <ValidationErrors errors={validationErrors}  onClose={clearValidationErrors} />
                                                    {error && <p className="text-danger">{error}</p>}
                                                    {success && <p className="text-success">{success}</p>}
                                                    <button className="btn bsb-btn-xl btn-primary" type="submit"> Iniciar sesión </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="row">
                                        <div className="text-end pt-4 pb-1">
                                            <Link to={ROUTES.FORGOT_PASSWORD} className="link-secondary text-decoration-none">¿Olvidaste tu contraseña?</Link>
                                        </div>
                                        <hr className='my-4' />
                                        <div className="d-flex align-items-center justify-content-center pb-4">
                                            <p className="mb-0 me-2 text-secondary">¿No tienes cuenta?</p>
                                            <Link to={ROUTES.REGISTER} type="button" data-mdb-button-init="" data-mdb-ripple-init="" className="btn btn-outline-danger" data-mdb-button-initialized="true">Registrate</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}